export enum StreamStatusType {
  Live = 'live',
  Wait = 'wait',
  View = 'view',
}
